/* Mirror the native purchase UI. No price calculations or extra cart requests. */
(() => {
  function init() {
    const bar = document.getElementById('sw-sticky');
    const initialForm = document.querySelector('form.f8pr-buy-button');
    if (!bar || !initialForm) return;
    const scope = initialForm.closest('.shopify-section');
    if (!scope) return;
    const button = bar.querySelector('button');
    let pending = false;
    const sync = () => {
      pending = false;
      const form = scope.querySelector('form.f8pr-buy-button');
      const nativeButton = form?.querySelector('.f8pr-button button[type=submit]');
      const price = scope.querySelector('.f8pr-price');
      // Native form handles all selected variants, preorders and selling plans.
      button.disabled = !nativeButton || nativeButton.disabled || nativeButton.classList.contains('disabled') || nativeButton.getAttribute('aria-disabled') === 'true';
      if (nativeButton && button.textContent.trim() !== nativeButton.textContent.trim()) button.textContent = nativeButton.textContent.trim();
      if (price) {
        const priceCopy = price.cloneNode(true);
        priceCopy.querySelectorAll('small,.small,.tax-info,.f8pr-tax').forEach(el => el.remove());
        const html = priceCopy.innerHTML;
        const output = bar.querySelector('.sw-s-price');
        if (output.innerHTML !== html) output.replaceChildren(...priceCopy.childNodes);
        const old = bar.querySelector('.sw-s-was');
        if (old) old.hidden = true;
      }
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(sync); } };
    // The bar is outside scope: its own updates cannot retrigger this observer.
    new MutationObserver(schedule).observe(scope, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    scope.addEventListener('change', schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
